/*
 * QEOPS - (c) WIDIP Software 2020e
 * Author EFWAY / F. Delaunay
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment as env } from '@src/environments/environment';
import { Contact } from '@src/app/_core/model/contact.model';
import { ItemTypeEnum } from '@src/app/_core/interfaces/rest-api.interfaces';
import { Sort, Pagination, PaginatedList } from '@src/app/_core/interfaces/app.interfaces';
import { ResourceQualifier, RestApiService } from '@src/app/_core/services/rest-api.service';

@Injectable({
    providedIn: 'root',
})
export class ContactService {

    private resource: ResourceQualifier = {
        itemType: ItemTypeEnum.CONTACT,
        parentType: ItemTypeEnum.ORGANIZATION,
    };

    constructor(
        private restApiService: RestApiService,
    ) {}

    getContactList(orgId: number, filter?: null, sort?:Sort, pagination?:Pagination): Observable<PaginatedList> {
        return this.restApiService.searchItems<Contact>({...this.resource, parentId: orgId}, filter, sort, pagination).pipe(
            map((response: PaginatedList) => {
                return <PaginatedList>{
                    total: response.total,
                    items: (response.items||[]).map(item => new Contact(item))
                } })
        );
    }

    getContact(id: number): Observable<Contact> {
        return this.restApiService.getItem<Contact>({...this.resource, itemId: id}).pipe(
            map((response) => new Contact(response))
        );
    }

    createContact(orgId: number, item: Contact): Observable<Contact> {
        return this.restApiService.postItem<Contact>({...this.resource, parentId: orgId}, item.buildBeRequest()).pipe(
            map((response) => new Contact(response))
        );
    }

    updateContact(item: Partial<Contact>): Observable<number> {
        return this.restApiService.putItem<Contact>({...this.resource, itemId: item.id}, item.buildBeRequest());
    }

    deleteContact(id: number): Observable<any> {
        return this.restApiService.deleteItem({...this.resource, itemId: id});
    }

}
